export default "__VITE_ASSET__BJPdNN6s__"